import React, { ComponentProps } from "react";
import styles from "./PrintOrderInfo.module.scss";
import Logo from "../../../UI/Logo/LogoBW";
import NBSQRCode from "../../../UI/NBSQRCode/NBSQRCode";

interface Props extends ComponentProps<any> {}

export type Ref = HTMLDivElement;

const PrintOrderInfo = React.forwardRef<Ref, Props>((props, ref) => {
  const { order } = props;

  // Calculate total number of items
  const totalItems =
    order.items?.reduce((total: number, item: any) => {
      return total + (item.quantity || 0);
    }, 0) || 0;

  // Get delivery type display name
  const getDeliveryTypeDisplay = (deliveryType: string) => {
    switch (deliveryType) {
      case "FAST_DELIVERY":
        return "Brza dostava";
      case "STANDARD_DELIVERY":
        return "Standardna dostava";
      case "PENSION_CARD_DELIVERY":
        return "Dostava penzionerima";
      case "PICK_UP_BY_FRIEND":
        return "Preuzima prijatelj";
      case "PICKUP":
        return "Lično preuzimanje";
      default:
        return deliveryType;
    }
  };

  // Check if this order needs delivery payment QR
  const needsDeliveryQR =
    order.userDeliveryResponse &&
    (order.deliveryType === "FAST_DELIVERY" ||
      order.deliveryType === "STANDARD_DELIVERY" ||
      order.deliveryType === "PENSION_CARD_DELIVERY");

  return (
    <div ref={ref} className={styles.PrintWrapper}>
      <Logo />

      {/* Order Header */}
      <div style={{ marginBottom: "20px" }}>
        <div>Broj porudžbine:</div>
        <div style={{ fontSize: "80px", fontWeight: "bold" }}>#{order.id}</div>
      </div>

      {/* Order Summary */}
      <div style={{ marginBottom: "30px" }}>
        <div
          style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "10px" }}
        >
          Pregled porudžbine
        </div>
        <div>
          Tip dostave:{" "}
          <strong>{getDeliveryTypeDisplay(order.deliveryType)}</strong>
        </div>
        <div>
          Broj stavki: <strong>{totalItems}</strong>
        </div>
        <div>
          Ukupna cena: <strong>{order.totalPrice} RSD</strong>
        </div>
        {order.deliveryPrice && order.deliveryPrice > 0 && (
          <div>
            Cena dostave: <strong>{order.deliveryPrice} RSD</strong>
          </div>
        )}
      </div>

      {/* Customer Information */}
      <div style={{ marginBottom: "30px" }}>
        <div
          style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "10px" }}
        >
          Podaci o klijentu:
        </div>
        <div style={{ fontWeight: "bold" }}>
          {order.firstName} {order.secondName}
        </div>
        <div style={{ fontWeight: "bold" }}>
          {order.userPhoneNumberForOrder}
        </div>
        {order.userAddressResponse && (
          <div>
            {order.userAddressResponse.name} {order.userAddressResponse.number}
            {order.userAddressResponse.apartment &&
              `/${order.userAddressResponse.apartment}`}
            , {order.userAddressResponse.city}
          </div>
        )}
      </div>

      {/* Volunteer Information (for delivery orders) */}
      {order.userDeliveryResponse && (
        <div style={{ marginBottom: "30px" }}>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            Dostavljač:
          </div>
          <div style={{ fontWeight: "bold" }}>
            {order.userDeliveryResponse.firstName}{" "}
            {order.userDeliveryResponse.secondName}
          </div>
          <div style={{ fontWeight: "bold" }}>
            {order.userDeliveryResponse.phoneNumber}
          </div>
        </div>
      )}

      {/* QR Code Section for Volunteer Deliveries */}
      {needsDeliveryQR && (
        <div style={{ marginBottom: "30px" }}>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              marginBottom: "15px",
              textAlign: "center",
            }}
          >
            Plaćanje dostave QR kodom
          </div>
          <NBSQRCode order={order} />
          <div
            style={{
              fontSize: "12px",
              color: "#666",
              textAlign: "center",
              marginTop: "10px",
              lineHeight: "1.4",
            }}
          >
            Skenirajte QR kod mobilnom aplikacijom vaše banke
            <br />
            za plaćanje dostave direktno dostavljaču
          </div>
        </div>
      )}

      {/* Pickup Instructions for Non-Delivery Orders */}
      {(order.deliveryType === "PICKUP" ||
        order.deliveryType === "PICK_UP_BY_FRIEND") && (
        <div
          style={{
            marginBottom: "30px",
            padding: "15px",
            backgroundColor: "#f8f9fa",
            border: "1px solid #dee2e6",
          }}
        >
          <div
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            Instrukcije za preuzimanje:
          </div>
          {order.deliveryType === "PICKUP" ? (
            <div>
              • Porudžbina se plaća pri preuzimanju u apoteci
              <br />
              • Molimo da ponesete validnu identifikaciju
              <br />• Ukupan iznos za plaćanje:{" "}
              <strong>{order.totalPrice} RSD</strong>
            </div>
          ) : (
            <div>
              • Osoba koja preuzima treba da ima ovaj ispis
              <br />
              • Potrebna je validna identifikacija
              <br />• Plaćanje pri preuzimanju:{" "}
              <strong>{order.totalPrice} RSD</strong>
            </div>
          )}
        </div>
      )}

      <br />
    </div>
  );
});

export default PrintOrderInfo;
